// Notas legales predefinidas para los billing entries.
// El valor guardado en `legalNote` es el TEXTO COMPLETO de la frase (no un
// código). Al cargar un billing se marca la opción cuyo texto coincida; si
// está vacío, la opción "Ninguna".

export const LEGAL_NOTE_REVERSE_CHARGE =
  "Operación localizada en sede del destinatario por aplicación del art. 69 uno de la ley 37/1992 / Supply of services to EU customer subject to the reverse charge Article 44 and 196 – Directive 2006/112/EC.";

export const LEGAL_NOTE_NO_VAT =
  "No sujeto a IVA con el acuerdo al artículo 69 Ley 37/92";

export const LEGAL_NOTE_OPTIONS: { value: string; labelKey: string }[] = [
  { value: "", labelKey: "billing.legalNoteOptions.none" },
  {
    value: LEGAL_NOTE_REVERSE_CHARGE,
    labelKey: "billing.legalNoteOptions.reverseCharge",
  },
  { value: LEGAL_NOTE_NO_VAT, labelKey: "billing.legalNoteOptions.noVat" },
];
